// ── 十二节令（节气）数据 ───────────────────────────────────────

/** 地支 → 生肖 */
export const BRANCH_TO_ZODIAC: Record<string, string> = {
  '寅': '虎', '卯': '兔', '辰': '龙', '巳': '蛇',
  '午': '马', '未': '羊', '申': '猴', '酉': '鸡',
  '戌': '狗', '亥': '猪', '子': '鼠', '丑': '牛',
};

/** 地支 → 示例干支年（天干五合配地支） */
export function getGanZhiYearExamples(branch: string): string[] {
  return ['甲', '丙', '戊', '庚', '壬'].map(g => `${g}${branch}`);
}

/** 节令索引 → 月支映射 */
export const JIE_QI_TO_BRANCH: Record<number, string> = {
  0: '寅', 1: '卯', 2: '辰', 3: '巳', 4: '午', 5: '未',
  6: '申', 7: '酉', 8: '戌', 9: '亥', 10: '子', 11: '丑',
};

/** 月支 → 节令索引映射 */
export const BRANCH_TO_JIE_QI: Record<string, number> = {
  '寅': 0, '卯': 1, '辰': 2, '巳': 3, '午': 4, '未': 5,
  '申': 6, '酉': 7, '戌': 8, '亥': 9, '子': 10, '丑': 11,
};

/** 月支 → 首用事藏干（人元司令分野第一段） */
export const BRANCH_FIRST_WUXING: Record<string, { stem: string; wuxing: string; color: string }> = {
  '寅': { stem: '戊', wuxing: '土', color: '#E8C39E' },
  '卯': { stem: '甲', wuxing: '木', color: '#7BC67E' },
  '辰': { stem: '乙', wuxing: '木', color: '#7BC67E' },
  '巳': { stem: '戊', wuxing: '土', color: '#E8C39E' },
  '午': { stem: '丙', wuxing: '火', color: '#D14B45' },
  '未': { stem: '丁', wuxing: '火', color: '#D14B45' },
  '申': { stem: '己', wuxing: '土', color: '#E8C39E' },
  '酉': { stem: '庚', wuxing: '金', color: '#C0C0C0' },
  '戌': { stem: '辛', wuxing: '金', color: '#C0C0C0' },
  '亥': { stem: '戊', wuxing: '土', color: '#E8C39E' },
  '子': { stem: '壬', wuxing: '水', color: '#4A90D9' },
  '丑': { stem: '癸', wuxing: '水', color: '#4A90D9' },
};

/** 节令 → 公历大概日期 */
export const JIE_QI_APPROX_DATE: Record<number, string> = {
  0: '2月3日~5日', 1: '3月5日~7日', 2: '4月4日~6日', 3: '5月5日~7日',
  4: '6月5日~7日', 5: '7月6日~8日', 6: '8月7日~9日', 7: '9月7日~9日',
  8: '10月8日~9日', 9: '11月7日~8日', 10: '12月6日~8日', 11: '1月5日~7日',
};

/** 节令释义 */
export const JIE_QI_MEANING: Record<number, string> = {
  0: '立春乃一年之始，阳气初升，万物复苏。此时北斗指向寅位，春气始至，冰雪消融，草木萌动，为一岁节气之首，标志新的干支年正式开始。',
  1: '惊蛰者，春雷始鸣，惊醒蛰虫。此时阳气大动，蛰伏之虫皆惊醒而出，春雷震动，万物生机勃发，农事始兴，卯月木气渐旺。',
  2: '清明者，天气清朗，万物明净。此时春深，桐始华，田鼠化为鴽，虹始见，万物生长旺盛，气清景明，辰月土气开始蓄藏。',
  3: '立夏者，春尽夏始，万物繁茂。此时蝼蝈鸣，蚯蚓出，王瓜生，阳气日盛，万物进入生长旺季，巳月火气渐炽。',
  4: '芒种者，有芒之谷可种也。此时螳螂生，鵙始鸣，反舌无声，农忙之时，麦收稻种，万物繁盛至极，午月火旺当令。',
  5: '小暑者，暑气初盛，尚未至极。此时温风至，蟋蟀居壁，鹰始挚，热浪渐起，未月土旺泄火，湿热交蒸。',
  6: '立秋者，秋气始至，万物收敛。此时凉风至，白露生，寒蝉鸣，阳气渐收，阴气渐长，申月金气渐旺。',
  7: '白露者，阴气渐重，露凝而白。此时鸿雁来，玄鸟归，群鸟养羞，酉月金气纯粹，肃杀当令，万物收敛。',
  8: '寒露者，露气寒冷，将欲凝结。此时鸿雁来宾，雀入大水为蛤，菊有黄华，戌月土旺收金，秋意渐深。',
  9: '立冬者，冬气始至，万物收藏。此时水始冰，地始冻，亥月水气渐旺，阳气潜藏，冬季正式开始。',
  10: '大雪者，雪量增大，覆盖大地。此时鹖鴠不鸣，虎始交，荔挺出，子月水极阴盛，天寒地冻，万物蛰伏。',
  11: '小寒者，寒气初盛，尚未至极。此时雁北乡，鹊始巢，雉始雊，丑月土旺藏水，天寒地冻，阳气暗中萌动。',
};

/** 生活建议 */
export const JIE_QI_TIPS: Record<number, string> = {
  0: '立春之时宜疏肝理气，多食芽菜以应春生之气。可适当增加户外活动，舒展筋骨，保持心情舒畅，为一整年开运之始。',
  1: '惊蛰之时宜养肝护目，防春困。饮食宜清淡，多食绿色蔬菜，避免过于油腻，注意防潮防霉，起居宜早睡早起。',
  2: '清明之时宜踏青祭祖，吐故纳新。可多食时令野菜，如荠菜、香椿，注意防风保暖，防花粉过敏，调节情志。',
  3: '立夏之时宜养心安神，防心火过旺。饮食宜清淡，多食苦味食物如苦瓜，午休片刻以养心神，避免情绪激动。',
  4: '芒种之时宜清热解暑，防湿热困脾。饮食宜清淡利湿，多食瓜果蔬菜，避免烈日暴晒，注意补水，午间宜小憩。',
  5: '小暑之时宜静心养神，防暑降温。饮食宜清凉，多食绿豆汤、莲子汤，避免剧烈运动，午间小憩，防中暑。',
  6: '立秋之时宜滋阴润肺，防秋燥。饮食宜酸甘润燥，多食梨、百合、银耳，逐渐减少生冷食物，适当收敛肺气。',
  7: '白露之时宜防秋燥，护肺养胃。早晚添衣保暖，饮食宜温润，多食蜂蜜、芝麻，注意防感冒，防秋燥伤肤。',
  8: '寒露之时宜保暖防寒，养肾固本。饮食宜温补，多食羊肉、红枣，注意足部保暖，早睡早起，防寒邪入侵。',
  9: '立冬之时宜温补养藏，防寒保暖。饮食宜温热，多食根茎类食物如红薯、萝卜，适当进补，早睡晚起，护阳气。',
  10: '大雪之时宜温补助阳，养肾防寒。饮食宜温热滋补，多食牛羊肉、核桃，注意关节保暖，减少外出，静心养神。',
  11: '小寒之时宜温补阳气，防寒固本。饮食宜热补，多食姜汤、桂圆，注意头部与足部保暖，静养为主，以待春来。',
};

// ── 五行生克工具函数 ─────────────────────────────────────────
import { ELEMENT_GENERATES, ELEMENT_OVERCOMES } from '@/utils/calcTools/unifiedRules';

/** 天干 → 五行 */
export function getStemWuxing(stem: string): string {
  const map: Record<string, string> = {
    '甲': '木', '乙': '木',
    '丙': '火', '丁': '火',
    '戊': '土', '己': '土',
    '庚': '金', '辛': '金',
    '壬': '水', '癸': '水',
  };
  return map[stem] || '';
}

/** 计算日主与该节气当令五行的生克关系描述 */
export function getWuxingRelationDesc(dayStem: string, termWuxing: string): string {
  const dayWuxing = getStemWuxing(dayStem);
  if (!dayWuxing || !termWuxing) return '';

  if (dayWuxing === termWuxing) {
    return '比和于我，同性相助，此时运势平稳，有同辈助力、朋友帮衬之象，但亦防比劫争财。';
  }

  if (ELEMENT_GENERATES[dayWuxing] === termWuxing) {
    return '受我之生，我泄气以生之，此时宜输出、付出、创作、表达，有泄秀生财、才华展露之象。';
  }
  if (ELEMENT_GENERATES[termWuxing] === dayWuxing) {
    return '生扶于我，得我之生扶，此时运势受助，有贵人提携、长辈关照、学业进步之象。';
  }
  if (ELEMENT_OVERCOMES[dayWuxing] === termWuxing) {
    return '受我之克，我克制以制之，此时宜进取、求财、掌控、竞争，有制财得财、建功立业之象。';
  }
  if (ELEMENT_OVERCOMES[termWuxing] === dayWuxing) {
    return '克制于我，受我之克，此时压力较大，有官非、制约、挑战、阻力之象，宜谨慎行事，以柔克刚。';
  }

  return '';
}